/**
 * Best score per game, kept in this browser. Never throws: if storage is blocked
 * or holds junk, the best is remembered for this page session only.
 */
const memory = new Map<string, number>();
const keyFor = (gameId: string) => `brickcity:best:${gameId}`;

function readStored(gameId: string): number {
  try {
    const raw = window.localStorage.getItem(keyFor(gameId));
    const n = raw === null ? 0 : Number(raw);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
  } catch {
    return 0;
  }
}

export function getBest(gameId: string): number {
  return Math.max(readStored(gameId), memory.get(gameId) ?? 0);
}

export function submitScore(gameId: string, score: number): { best: number; isNewBest: boolean } {
  const previous = getBest(gameId);
  const isNewBest = score > previous;
  const best = isNewBest ? score : previous;
  memory.set(gameId, best);
  if (isNewBest) {
    try {
      window.localStorage.setItem(keyFor(gameId), String(best));
    } catch {
      // Storage blocked: keep the in-memory best.
    }
  }
  return { best, isNewBest };
}
